import { render, staticRenderFns } from "./AdminTab_Role_Assign.vue?vue&type=template&id=653caf70&scoped=true"
import script from "./AdminTab_Role_Assign.vue?vue&type=script&lang=js"
export * from "./AdminTab_Role_Assign.vue?vue&type=script&lang=js"
import style0 from "./AdminTab_Role_Assign.vue?vue&type=style&index=0&id=653caf70&prod&scoped=true&lang=css"
import style1 from "./AdminTab_Role_Assign.vue?vue&type=style&index=1&id=653caf70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653caf70",
  null
  
)

export default component.exports